module.exports = __webpack_public_path__ + "img/brazil.df1d8428.png";